import { ApolloClient, ApolloLink, NormalizedCacheObject } from '@apollo/client'
import { ErrorResponse, onError } from '@apollo/client/link/error'
import { SchemaLink } from '@apollo/client/link/schema'

import { authRedirectErrorLink, graphqlErrorLink, lutherErrorLink } from '@acre/utils'
import { schema } from '@acre/graphql'

import cache from './cache'

const initApollo = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    connectToDevTools: true,
    link: ApolloLink.from([
      onError(graphqlErrorLink),
      onError(lutherErrorLink),
      onError((error: ErrorResponse) => authRedirectErrorLink(error, client)),
      new SchemaLink({
        schema,
        context: (operation) => operation.getContext(),
      }),
    ]),
    cache,
  })

  return client
}

export default initApollo

export const client = initApollo()
